import * as yup from "yup";
export const replaceUnderscore = (name) => {
  if (name) {
    return name.replaceAll("_", " ");
  }
};
/**
 * The function creates an object with key-value pairs based on the input data, where the keys are the
 * names of the fields and the values are initially set to an empty string, except for subfields under
 * "Sidebyside" and "Bank details" which are also included as key-value pairs.
 * @param data - an array of objects containing information about form fields, including their names
 * and values.
 * @returns The function `formikinitialvalues` returns an object containing key-value pairs. The keys
 * are the names of the fields in the `data` array, and the values are either an empty string (if the
 * field is not a subfield) or the value of the subfield (if the field is a "Sidebyside" or "Bank
 * details" field with subfields).
 */
export const formikinitialvalues = (data) => {
  let keyvaluepairs = {};
  for (let a = 0; a < data?.length; a++) {
    if (data[a].name === "Sidebyside") {
      for (let b = 0; b < data[a].Subfields.length; b++) {
        keyvaluepairs = {
          ...keyvaluepairs,
          [data[a].Subfields[b].name]: data[a].Subfields[b].type === "Check-Box" ? false : null,
        };
      }
    } else {
      keyvaluepairs = {
        ...keyvaluepairs,
        [data[a].name]: data[a].type === "Check-Box" ? false : null,
      };
    }
  }
  return keyvaluepairs;
};

/**
 * The function creates a Yup validation schema based on the input data, which includes checking for
 * required fields, minimum and maximum lengths, and specific data types.
 * @param data - The `data` parameter is an array of objects that represent the fields in a form. Each
 * object contains information about the field, such as its name, type, and validation requirements.
 * The function uses this data to generate a Yup validation schema for the form.
 * @returns a Yup object schema that is generated based on the input data. The schema includes
 * validation rules for each field in the data, such as required fields, minimum and maximum lengths,
 * and number formats.
 */
export const formikValidation = (data) => {
  let formSchema = {};
  for (let a = 0; a < data?.length; a++) {
    if (data[a].isRequired) {
      if (data[a].ValidationType === "GST") {
        formSchema[data[a].name] = yup
          .string()
          .nullable(true)
          .transform((value) => (value === "" ? null : value))
          .min(data[a].min, "Invalid GSTIN")
          .max(data[a].max, "Invalid GSTIN")
          .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, "Invalid GSTIN");
      } else if (data[a].ValidationType === "String") {
        formSchema[data[a].name] = yup.string().required("  required.");
      } else if (data[a].ValidationType === "EMAIL") {
        formSchema[data[a].name] = yup
          .string()
          .nullable(true)
          .transform((value, originalValue) => (originalValue.trim() === "" ? null : value))
          .email("Invalid email format")
          .notRequired();
      }
    }
  }
  return yup.object().shape(formSchema);
};

/**
 * The function handles keydown events and prevents non-numeric input for a specified input type.
 * @param evt - The event object that is passed to the function when a key is pressed. It contains
 * information about the key that was pressed, such as the key code and whether any modifier keys (e.g.
 * Shift, Ctrl) were pressed at the same time.
 * @param type - The type of input expected, which in this case is "number".
 */

export const NumberFormatter = (number) => {
  if (number === 0 || isNaN(number)) {
    return "0.00";
  }

  const formattedNumber = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(number));

  return number < 0 ? `-${formattedNumber}` : formattedNumber;
};

export const valueAfterDecimalPoint = (number) => {
  if (number === 0) {
    return number;
  }
  const formattedNumber = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(number);

  const fractionalPart = formattedNumber.split(".")[1];
  if (100 - Number(fractionalPart) === 100) {
    return 0;
  }
  return fractionalPart ? 100 - Number(fractionalPart) : 0;
};

export const DecimalToNum = (number) => {
  if (number === 0 || number === "0" || number === "NaN") {
    return 0;
  }
  if (typeof number === "number") {
    return number;
  }
  const fractionalPart = number.replace(/,/g, "").split(".")[0];
  return Number(fractionalPart);
};

export const InNumber = (number) => {
  if (number === 0 || number === "0" || number === "NaN") {
    return 0;
  }
  if (typeof number === "number") {
    return number;
  }
  const num = number.replace(/,/g, "");
  const formattedNumber = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(num);
  return Number(formattedNumber);
};


export const getFirstSegment = (pathname) => {

  if (pathname.includes("Ref")) {
    // return "/ReceivableBillByBill"
  }
  // remove leading/trailing slashes, then split
  const cleaned = pathname.replace(/(^\/+|\/+$)/g, "");
  const segments = cleaned.split("/");
  return `/${segments[0]}`;
};